const FiveSignsYouNeedCustomSoftwareStyles = () => {
  return (
    <style jsx>{`
      .lead-magnet-container {
        font-family:
          -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        min-height: 100vh;
        background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
      }

      /* Modal Styles */
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(10, 36, 88, 0.4);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        padding: 20px;
      }

      .modal-content {
        background: white;
        border-radius: 24px;
        max-width: 500px;
        width: 100%;
        box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
        animation: modalSlideIn 0.5s ease;
      }

      @keyframes modalSlideIn {
        from {
          opacity: 0;
          transform: translateY(30px) scale(0.95);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      .modal-header {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        padding: 40px;
        border-radius: 24px 24px 0 0;
        text-align: center;
      }

      .modal-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 20px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .badge-icon {
        font-size: 20px;
      }

      .badge-text {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .modal-title {
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 12px;
      }

      .modal-subtitle {
        font-size: 1.125rem;
        opacity: 0.9;
        line-height: 1.5;
      }

      .modal-body {
        padding: 40px;
      }

      .form-group {
        margin-bottom: 24px;
      }

      .form-label {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        font-weight: 600;
        color: #0a2458;
      }

      .required {
        color: #e53e3e;
        font-size: 0.875rem;
      }

      .optional {
        color: #0a2458;
        font-size: 0.875rem;
      }

      .form-input {
        width: 100%;
        padding: 14px 16px;
        border: 2px solid #e2e8f0;
        border-radius: 12px;
        font-size: 1rem;
        transition: all 0.3s ease;
      }

      .form-input:focus {
        outline: none;
        border-color: #0a2458;
        box-shadow: 0 0 0 3px rgba(10, 36, 88, 0.1);
      }

      .form-help {
        display: block;
        margin-top: 4px;
        color: #0a2458;
        font-size: 0.875rem;
      }

      .error-message {
        background: #fed7d7;
        color: #c53030;
        padding: 12px 16px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 20px;
      }

      .error-icon {
        font-size: 20px;
      }

      .form-actions {
        display: flex;
        gap: 12px;
        margin-bottom: 20px;
      }

      .btn {
        flex: 1;
        padding: 16px 24px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 1rem;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }

      .btn-primary {
        background: linear-gradient(135deg, #ffd700 0%, #ffc107 100%);
        color: #0a2458;
        border: none;
      }

      .btn-primary:hover:not(:disabled) {
        transform: translateY(-2px);
        color: #0a2458;
        box-shadow: 0 10px 20px rgba(255, 215, 0, 0.3);
      }

      .btn-secondary {
        background: transparent;
        color: #0a2458;
        border: 2px solid #0a2458;
      }

      .btn-secondary:hover:not(:disabled) {
        background: rgba(10, 36, 88, 0.05);
        color: #0a2458;
      }

      .btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(10, 36, 88, 0.3);
        border-top-color: #0a2458;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }

      .privacy-note {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0a2458;
        font-size: 0.875rem;
        text-align: center;
        justify-content: center;
        padding-top: 16px;
        border-top: 1px solid #e2e8f0;
      }

      /* Main Content Styles */
      .lead-magnet-wrapper {
        max-width: 1200px;
        margin: 0 auto;
        padding: 20px;
        padding-top: 80px;
      }

      /* Progress Container */
      .progress-container {
        position: relative;
        height: 8px;
        background: #e2e8f0;
        border-radius: 4px;
        margin-bottom: 40px;
        overflow: hidden;
      }

      .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #0a2458, #1a3b8a, #ffd700);
        border-radius: 4px;
        transition: width 0.3s ease;
      }

      .progress-text {
        position: absolute;
        top: -25px;
        right: 0;
        font-size: 0.875rem;
        color: #0a2458;
        font-weight: 600;
      }

      /* Hero Slide */
      .lead-magnet-hero {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 24px;
        padding: 60px 40px;
        color: white;
        text-align: center;
        margin-bottom: 40px;
      }

      .hero-content {
        max-width: 800px;
        margin: 0 auto;
      }

      .hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(10px);
        padding: 8px 16px;
        border-radius: 50px;
        margin-bottom: 24px;
        border: 1px solid rgba(255, 255, 255, 0.2);
      }

      .hero-title {
        font-size: clamp(2.5rem, 5vw, 3.5rem);
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
      }

      .highlight {
        background: linear-gradient(90deg, #ffd700 0%, #ffec8b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .hero-subtitle {
        font-size: 1.5rem;
        color: rgba(255, 255, 255, 0.9);
        margin-top: 12px;
      }

      .hero-description {
        font-size: 1.25rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.9);
        max-width: 600px;
        margin: 0 auto 40px;
      }

      .hero-stats {
        display: flex;
        justify-content: center;
        gap: 40px;
        flex-wrap: wrap;
      }

      .stat-item {
        text-align: center;
        min-width: 120px;
      }

      .stat-value {
        font-size: 2.5rem;
        font-weight: 700;
        color: #ffd700;
        margin-bottom: 4px;
      }

      .stat-label {
        font-size: 0.875rem;
        color: rgba(255, 255, 255, 0.8);
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      /* Content Slides */
      .content-slide {
        background: white;
        border-radius: 24px;
        padding: 40px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        margin-bottom: 40px;
      }

      .slide-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 32px;
        padding-bottom: 16px;
        border-bottom: 2px solid #f0f2f5;
      }

      .slide-number {
        width: 50px;
        height: 50px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: 700;
        flex-shrink: 0;
      }

      .slide-title {
        font-size: 2rem;
        color: #0a2458;
        margin: 0;
        flex: 1;
      }

      .slide-content {
        color: #0a2458;
      }

      .slide-text {
        font-size: 1.125rem;
        line-height: 1.6;
        margin-bottom: 24px;
      }

      /* Cards */
      .info-card {
        background: linear-gradient(
          135deg,
          rgba(10, 36, 88, 0.05) 0%,
          rgba(255, 215, 0, 0.05) 100%
        );
        border-left: 4px solid #ffd700;
        border-radius: 12px;
        padding: 24px;
        margin: 32px 0;
      }

      .info-card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
      }

      .info-icon {
        font-size: 24px;
      }

      .info-card h3 {
        color: #0a2458;
        margin: 0;
      }

      .info-card-text {
        font-size: 1.125rem;
        line-height: 1.6;
        margin: 0;
      }

      .cta-box {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 16px;
        padding: 32px;
        color: white;
        display: flex;
        gap: 24px;
        margin: 32px 0;
      }

      .cta-icon {
        font-size: 48px;
        flex-shrink: 0;
      }

      .cta-content h4 {
        font-size: 1.5rem;
        margin-bottom: 16px;
      }

      .cta-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .cta-list li {
        margin-bottom: 8px;
        padding-left: 24px;
        position: relative;
      }

      .cta-list li:before {
        content: "✓";
        position: absolute;
        left: 0;
        color: #ffd700;
        font-weight: bold;
      }

      /* Symptom Cards */
      .symptom-card {
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        padding: 24px;
        margin: 24px 0;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
      }

      .symptom-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
      }

      .symptom-icon {
        font-size: 24px;
        width: 48px;
        height: 48px;
        background: rgba(10, 36, 88, 0.1);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .symptom-header h3 {
        color: #0a2458;
        margin: 0;
        font-size: 1.25rem;
      }

      .symptom-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .symptom-list li {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 12px 0;
        border-bottom: 1px solid #f1f5f9;
      }

      .symptom-list li:last-child {
        border-bottom: none;
      }

      .list-icon {
        font-size: 20px;
        flex-shrink: 0;
        margin-top: 2px;
      }

      /* Impact Cards */
      .impact-card {
        background: rgba(255, 215, 0, 0.05);
        border: 1px solid rgba(255, 215, 0, 0.2);
        border-radius: 16px;
        padding: 24px;
        margin: 24px 0;
      }

      .impact-card h3 {
        color: #0a2458;
        margin-bottom: 16px;
      }

      .impact-text {
        font-size: 1.125rem;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .stat-box {
        text-align: center;
        padding: 16px;
        background: white;
        border-radius: 12px;
        border: 2px solid #ffd700;
      }

      .stat-number {
        display: block;
        font-size: 2rem;
        font-weight: 700;
        color: #0a2458;
        margin-bottom: 4px;
      }

      .stat-unit {
        font-size: 0.875rem;
        color: #0a2458;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      /* Solution Cards */
      .solution-card {
        background: linear-gradient(
          135deg,
          rgba(10, 36, 88, 0.08) 0%,
          rgba(10, 36, 88, 0.04) 100%
        );
        border-left: 4px solid #0a2458;
        border-radius: 12px;
        padding: 24px;
        margin: 24px 0;
      }

      .solution-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
      }

      .solution-icon {
        font-size: 24px;
      }

      .solution-header h3 {
        color: #0a2458;
        margin: 0;
      }

      .solution-text {
        font-size: 1.125rem;
        line-height: 1.6;
        margin: 0;
      }

      /* Question Box */
      .question-box {
        background: #f8fafc;
        border-radius: 16px;
        padding: 24px;
        margin: 32px 0;
      }

      .question-title {
        color: #0a2458;
        margin-bottom: 16px;
        font-size: 1.25rem;
      }

      .question-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .question-list li {
        margin-bottom: 12px;
        padding-left: 28px;
        position: relative;
      }

      .question-list li:before {
        content: "?";
        position: absolute;
        left: 0;
        width: 20px;
        height: 20px;
        background: #0a2458;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
      }

      /* Summary Card */
      .summary-card {
        background: white;
        border: 2px solid #e2e8f0;
        border-radius: 16px;
        padding: 32px;
        margin: 32px 0;
      }

      .summary-card h3 {
        color: #0a2458;
        margin-bottom: 24px;
        text-align: center;
        font-size: 1.5rem;
      }

      .reality-list {
        max-width: 600px;
        margin: 0 auto;
      }

      .reality-item {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px;
        margin-bottom: 16px;
        background: rgba(10, 36, 88, 0.02);
        border-radius: 12px;
        border: 1px solid rgba(10, 36, 88, 0.1);
      }

      .reality-icon {
        font-size: 24px;
        width: 48px;
        height: 48px;
        background: rgba(10, 36, 88, 0.1);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .reality-content {
        flex: 1;
        font-size: 1.125rem;
        line-height: 1.5;
      }

      /* Benefits Grid */
      .benefits-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 24px;
        margin: 40px 0;
      }

      .benefit-card {
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        padding: 24px;
        text-align: center;
        transition: transform 0.3s ease;
      }

      .benefit-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      }

      .benefit-icon {
        font-size: 32px;
        margin-bottom: 16px;
      }

      .benefit-card h4 {
        color: #0a2458;
        margin-bottom: 8px;
        font-size: 1.125rem;
      }

      .benefit-card p {
        font-size: 0.875rem;
        color: #0a2458;
        margin: 0;
        line-height: 1.5;
      }

      /* Final CTA */
      .final-cta {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 20px;
        padding: 48px;
        text-align: center;
        color: white;
        margin: 40px 0;
      }

      .cta-title {
        font-size: 1.5rem;
        margin-bottom: 16px;
        line-height: 1.3;
      }

      .highlight-success {
        color: #ffd700;
        font-weight: 700;
      }

      /* Action Slide */
      .action-hero {
        text-align: center;
        margin-bottom: 40px;
      }

      .action-title {
        font-size: 2rem;
        color: #0a2458;
        margin-bottom: 16px;
      }

      .action-subtitle {
        font-size: 1.125rem;
        color: #0a2458;
        max-width: 600px;
        margin: 0 auto;
      }

      /* Discussion Grid */
      .discussion-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 24px;
        margin: 40px 0;
      }

      .discussion-item {
        text-align: center;
        padding: 24px;
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
      }

      .discussion-icon {
        font-size: 32px;
        margin-bottom: 16px;
      }

      .discussion-item h4 {
        color: #0a2458;
        margin-bottom: 8px;
        font-size: 1.125rem;
      }

      .discussion-item p {
        font-size: 0.875rem;
        color: #0a2458;
        margin: 0;
      }

      /* Action Buttons */
      .action-buttons {
        margin: 40px 0;
      }

      .primary-btn {
        display: block;
        width: 100%;
        padding: 20px;
        background: linear-gradient(135deg, #ffd700 0%, #ffc107 100%);
        color: #0a2458;
        border: none;
        border-radius: 16px;
        font-size: 1.125rem;
        font-weight: 600;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        transition: all 0.3s ease;
        margin-bottom: 16px;
      }

      .primary-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 30px rgba(255, 215, 0, 0.3);
      }

      .contact-buttons {
        display: flex;
        gap: 16px;
      }

      .action-btn {
        flex: 1;
        padding: 16px 24px;
        border-radius: 12px;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-weight: 600;
        transition: all 0.3s ease;
      }

      .secondary-btn {
        background: white;
        color: #0a2458;
        border: 2px solid #0a2458;
      }

      .secondary-btn:hover {
        background: rgba(10, 36, 88, 0.05);
        transform: translateY(-2px);
      }

      .whatsapp-btn {
        background: #25d366;
        color: white;
        border: none;
      }

      .whatsapp-btn:hover {
        background: #128c7e;
        transform: translateY(-2px);
      }

      .guarantee-box {
        background: linear-gradient(
          135deg,
          rgba(10, 36, 88, 0.05) 0%,
          rgba(255, 215, 0, 0.05) 100%
        );
        border-radius: 16px;
        padding: 24px;
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 32px;
      }

      .guarantee-icon {
        font-size: 32px;
      }

      .guarantee-content h4 {
        color: #0a2458;
        margin-bottom: 8px;
      }

      .guarantee-content p {
        margin: 0;
        color: #0a2458;
      }

      /* Navigation */
      .navigation-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-top: 1px solid #e2e8f0;
      }

      .nav-btn {
        padding: 12px 24px;
        border-radius: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
        background: white;
        border: 2px solid #e2e8f0;
        color: #0a2458;
      }

      .nav-btn:hover:not(:disabled) {
        background: #f8fafc;
        border-color: #0a2458;
        color: #0a2458;
      }

      .nav-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .slide-indicators {
        display: flex;
        gap: 8px;
      }

      .slide-indicator {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #e2e8f0;
        border: none;
        cursor: pointer;
        padding: 0;
        transition: all 0.3s ease;
      }

      .slide-indicator.active {
        background: #0a2458;
        width: 24px;
        border-radius: 4px;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .lead-magnet-wrapper {
          padding: 10px;
          padding-top: 60px;
        }

        .lead-magnet-hero {
          padding: 40px 20px;
        }

        .hero-title {
          font-size: 2rem;
        }

        .hero-stats {
          gap: 20px;
        }

        .stat-item {
          min-width: 100px;
        }

        .stat-value {
          font-size: 2rem;
        }

        .content-slide {
          padding: 24px;
        }

        .slide-title {
          font-size: 1.5rem;
        }

        .cta-box {
          flex-direction: column;
          text-align: center;
        }

        .benefits-grid {
          grid-template-columns: 1fr;
        }

        .contact-buttons {
          flex-direction: column;
        }

        .modal-header {
          padding: 30px 20px;
        }

        .modal-body {
          padding: 30px 20px;
        }

        .form-actions {
          flex-direction: column;
        }

        .navigation-container {
          flex-direction: column;
          gap: 20px;
        }

        .slide-indicators {
          order: 2;
        }

        .prev-btn {
          order: 1;
        }

        .next-btn {
          order: 3;
        }
      }
    `}</style>
  );
};
export default FiveSignsYouNeedCustomSoftwareStyles;
